/** Quotes the API will not allow to be updated via PUT (accepted, rejected, invoiced). */
export function isQuoteStatusLocked (quote) {
  if (!quote) return false
  const status = quote.status != null ? String(quote.status).toLowerCase() : ''
  if (status === 'accepted' || status === 'rejected' || status === 'declined' || status === 'invoiced') {
    return true
  }
  const statusId = Number(quote.status_id)
  return statusId === 3 || statusId === 5 || statusId === 6
}

const STATUS_ID_FROM_KEY = {
  draft: 1,
  sent: 2,
  accepted: 3,
  invoiced: 5,
  declined: 6,
  rejected: 6
}

const STATUS_KEY_FROM_ID = {
  1: 'draft',
  2: 'sent',
  3: 'accepted',
  5: 'invoiced',
  6: 'rejected'
}

/** Map UI / API status values to a numeric status_id, or null if unknown. */
export function normalizeQuoteStatusId (value) {
  if (value == null || value === '') return null
  if (typeof value === 'number' && Number.isFinite(value)) {
    return STATUS_KEY_FROM_ID[value] ? value : null
  }
  const raw = String(value).trim().toLowerCase()
  if (/^\d+$/.test(raw)) {
    const n = Number(raw)
    return STATUS_KEY_FROM_ID[n] ? n : null
  }
  return STATUS_ID_FROM_KEY[raw] != null ? STATUS_ID_FROM_KEY[raw] : null
}

/** Ensure quote.status_id is numeric before PUT; drop invalid string keys like "draft". */
export function coerceQuoteStatusFields (quote) {
  if (!quote || typeof quote !== 'object') return quote
  const fromId = normalizeQuoteStatusId(quote.status_id)
  const fromStatus = normalizeQuoteStatusId(quote.status)
  const statusId = fromId != null ? fromId : fromStatus
  if (statusId != null) {
    quote.status_id = statusId
    if (!quote.status || normalizeQuoteStatusId(quote.status) == null) {
      quote.status = STATUS_KEY_FROM_ID[statusId] || quote.status
    }
  } else if (quote.status_id != null && normalizeQuoteStatusId(quote.status_id) == null) {
    delete quote.status_id
  }
  return quote
}
